"use strict";
'use strict';

var dialog = require('./dialog.cjs');



exports.ActionTrigger = dialog.DialogActionTrigger;
exports.Backdrop = dialog.DialogBackdrop;
exports.Body = dialog.DialogBody;
exports.CloseTrigger = dialog.DialogCloseTrigger;
exports.Content = dialog.DialogContent;
exports.Context = dialog.DialogContext;
exports.Description = dialog.DialogDescription;
exports.Footer = dialog.DialogFooter;
exports.Header = dialog.DialogHeader;
exports.Positioner = dialog.DialogPositioner;
exports.PropsProvider = dialog.DialogPropsProvider;
exports.Root = dialog.DialogRoot;
exports.RootProvider = dialog.DialogRootProvider;
exports.Title = dialog.DialogTitle;
exports.Trigger = dialog.DialogTrigger;
